exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pre-intake--QKkVdRvYo8IKMaPK8IXzg {\n  display: flex;\n  flex-direction: row;\n  align-items: start;\n  position: relative;\n  column-gap: 1rem;\n  border: .125rem solid #4e89a4;\n  border-radius: .5rem;\n  background: #fff;\n  padding: .75rem 1.25rem;\n  margin-top: 1.5rem;\n}\n\n.pre-intake--QKkVdRvYo8IKMaPK8IXzg > form {\n  display: contents;\n}\n", ""]);

// exports
exports.locals = {
	"container": "pre-intake--QKkVdRvYo8IKMaPK8IXzg",
	"container": "pre-intake--QKkVdRvYo8IKMaPK8IXzg"
};